// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".aeq-radio[data-v-f7bc8f3e]{margin-right:10px!important;padding-right:2px}.v-input--radio-group legend[data-v-f7bc8f3e]{display:table;padding-bottom:2px}div.checkbox-label[data-v-f7bc8f3e]{padding:0 12px;white-space:pre-line}.change-primary-color[data-v-f7bc8f3e]{--v-primary-base:#46649a!important}.change-primary-color[disabled=disabled] .checkbox-label[data-v-f7bc8f3e]{opacity:.38}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
